import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { Select } from 'module/ui/components/atoms/select';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';
import {
  components as ReactSelectComponents,
  DropdownIndicatorProps,
} from 'react-select';
import styled from 'styled-components';

export const StyledSelect = styled(Select)`
  .ozone-select__control {
    display: flex;
    flex: 1;
  }
`;

const DropdownIndicator = (props: DropdownIndicatorProps<any, true>) => (
  <ReactSelectComponents.DropdownIndicator {...props}>
    <FontAwesomeIcon icon={faSearch} size={12} />
  </ReactSelectComponents.DropdownIndicator>
);

const PopoverSelect = styled(StyledSelect).attrs(({ components = {} }) => ({
  menuIsOpen: true,
  hideSelectedOptions: false,
  components: {
    DropdownIndicator,
    ...components,
  },
}))`
  font-family: var(--ozn-font-sans);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .ozone-select__control {
    margin: var(--spacing-02) var(--spacing-04);
    flex: 1 0 auto;
    height: 32px;
    border-radius: var(--spacing-03);
    display: flex;
    justify-content: space-between;
    flex-direction: row-reverse;
    padding: var(--spacing-02);
    border: 1px solid var(--scarlet-gray-40);
  }

  .ozone-select__menu {
    border: none;
    box-shadow: none;
    position: initial;
    margin: 0;
    flex: 1 1 100%;
    overflow-y: auto;
  }

  .ozone-select__menu-list {
    max-height: 100%;
  }

  .ozone-select__value-container {
    overflow: hidden;
    overflow-y: auto;
    padding: 0;
  }

  .ozone-select__placeholder {
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-regular);
    line-height: var(--line-height-body-short-01);
  }

  .ozone-select__indicators {
    .ozone-select__indicator-separator {
      display: none;
    }

    .ozone-select__dropdown-indicator {
      justify-content: center;
      padding: 0;
      color: var(--text-primary);
      width: var(--height-sm);
      height: var(--height-sm);
      align-items: center;
    }
  }

  .ozone-select__option {
    cursor: pointer;
    width: auto;
    border-radius: var(--border-radius-default);
    margin: var(--spacing-02) var(--spacing-02);

    &.ozone-select__option--is-focused {
      background-color: var(--gray-10);
      color: inherit;

      &:hover {
        background-color: var(--gray-10);
      }
    }

    &.ozone-select__option--is-selected {
      background-color: var(--blue-20);
      color: inherit;
      &:hover {
        background-color: var(--blue-20);
      }
    }
  }
`;

export { PopoverSelect };
